import * as React from 'react';
import type { SVGProps } from 'react';

const IconOrgChart = (props: SVGProps<SVGSVGElement>) => {
  const maskID = 'iconorgchart';

  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 1600" {...props}>
      <g clipPath={`url(#${maskID})`}>
        <path
          d="M1413.33 1095.17V773.333H826.667V504.827c105.068-13.198 186.663-102.907 186.663-211.494C1013.33 175.708 917.625 80 800 80c-117.625 0-213.333 95.708-213.333 213.333 0 108.588 81.598 198.294 186.666 211.494v268.506H186.667v321.837C81.599 1108.38 0 1198.08 0 1306.67 0 1424.29 95.708 1520 213.333 1520c117.626 0 213.334-95.71 213.334-213.33 0-108.59-81.599-198.3-186.667-211.5V826.667h533.333v268.503c-105.068 13.2-186.666 102.91-186.666 211.5 0 117.62 95.708 213.33 213.333 213.33s213.33-95.71 213.33-213.33c0-108.59-81.595-198.3-186.663-211.5V826.667H1360v268.503c-105.07 13.2-186.67 102.91-186.67 211.5 0 117.62 95.71 213.33 213.34 213.33 117.62 0 213.33-95.71 213.33-213.33 0-108.59-81.6-198.3-186.67-211.5ZM640 293.333c0-88.24 71.76-160 160-160s160 71.76 160 160-71.76 160-160 160-160-71.76-160-160ZM373.333 1306.67c0 88.24-71.76 160-160 160s-160-71.76-160-160 71.76-160 160-160 160 71.76 160 160Zm586.667 0c0 88.24-71.76 160-160 160s-160-71.76-160-160 71.76-160 160-160 160 71.76 160 160Zm426.67 160c-88.24 0-160-71.76-160-160s71.76-160 160-160 160 71.76 160 160-71.76 160-160 160Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={maskID}>
          <path fill="#fff" d="M0 0h1600v1600H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconOrgChart;
